var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},_vm._l((_vm.errors),function(error){return _c('div',{staticClass:"text-danger text-center"},[_vm._v("\n        "+_vm._s(error)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }